<script setup lang="ts">
import { PhInfo as InfoIcon, PhX as XIcon } from '@phosphor-icons/vue'
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { RouterView } from 'vue-router'
import AppFooter from './components/AppFooter.vue'
import AppHeader from './components/AppHeader.vue'
import { api } from './services/api'

const demoMode = ref(false)
const demoBannerVisible = ref(true)

const enableDemoMode = () => {
  demoMode.value = true
}

onMounted(() => window.addEventListener(api.demoModeEvent, enableDemoMode))
onBeforeUnmount(() => window.removeEventListener(api.demoModeEvent, enableDemoMode))
</script>

<template>
  <a class="skip-link" href="#main-content">跳到主要内容</a>
  <div class="app-shell">
    <div v-if="demoMode && demoBannerVisible" class="demo-banner" role="status">
      <div class="container demo-banner__inner">
        <InfoIcon :size="18" weight="fill" aria-hidden="true" />
        <span>当前后端未连接，页面正在使用演示数据。正式接入后将自动切换真实业务数据。</span>
        <button
          class="icon-button icon-button--compact"
          type="button"
          aria-label="关闭演示数据提示"
          @click="demoBannerVisible = false"
        >
          <XIcon :size="17" aria-hidden="true" />
        </button>
      </div>
    </div>
    <AppHeader />
    <main id="main-content" class="app-main">
      <RouterView />
    </main>
    <AppFooter />
  </div>
</template>
